export default "__VITE_ASSET__BPUNqm5b__"